var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
	var $toggleButton = $('.header__hamburger');
    var $drawerWraper = $('.header__navigation');
    var $menuItem = $('.header .menu .menu__item');
    var $menuItemMobile = $('.header .menu .menu__item .icon');

    if (!$menuItem.length) {
        return;
    }
    
    $toggleButton.on('click', function(e) {
        e.preventDefault();
        
        $('.menu__mega_nav').removeAttr('style');
        $('.menu__mega_list').removeAttr('style');

        $('body').toggleClass('locked');

        $drawerWraper.toggleClass('is_open');
        $(this).toggleClass('is_open');
    });


    // DESKTOP
    $menuItem.on('mouseenter', function(e) {
        if (checkVPW() < 1024) { return; };

        $menuItem.removeClass("active");
        
        // Set MegaMenu Height
        var $maxHeight = 0;
        $(this).find('.menu__mega_list').each(function(){
            var $height = $(this).height();

            if ($height > $maxHeight) { 
                $maxHeight = $height; 
            }
        });

        if ($maxHeight>0) {
            $('.menu__mega_nav').height($maxHeight);
            $('.menu__mega_list').height($maxHeight);
        }

        // Open Menu
         $(this).delay(100).queue(function(){
            $(this).addClass("active").dequeue();
        });

    }).on('mouseleave', function(e) {
        if (checkVPW() < 1024) { return; };

        $(this).removeClass("active").dequeue();
        $('.menu__mega_list').removeAttr('style');
    });


    $('.menu__mega_list li.have_submenu').on('mouseenter', function(e) {
        if (checkVPW() < 1024) { return; };

        $(this).addClass("active");
    }).on('mouseleave', function(e) {
        if (checkVPW() < 1024) { return; };

        $(this).removeClass("active");
    });



    // MOBILE
    $menuItemMobile.on('click', function(e) {
        if (checkVPW() > 1023) { return; };

        e.preventDefault();
        $(this).closest('li').toggleClass("active");
    });


    $('.menu__mega_list li.have_submenu a:after').on('click', function(e) {
        if (checkVPW() > 1023) { return; };

        e.preventDefault();
        $(this).closest('li').toggleClass("active");
    });



    function checkVPW() {
        return $(window).width();
    }
}


// Toogle Menu
//-----------------------------------------------------------------
mp.searchToggle = function() {
    var $toggleButton = $('.header__search_toggle');
    var $toggleCloseButton = $('.header__search_close');
    var $drawerWraper = $('.header__search');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('click', function(e) {
        e.preventDefault();
        
        $drawerWraper.addClass('is_open');
    });

    $toggleCloseButton.on('click', function(e) {
        e.preventDefault();
        
        $drawerWraper.removeClass('is_open');
    });
}


$(document).ready(function(){
    mp.MenuToggle();
    mp.searchToggle();
});